
import { defineComponent } from "vue";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "vuex";
import { StoreState } from "@/interfaces";

export default defineComponent({
  name: "BecomeDealerButton",
  setup() {
    const store = useStore<StoreState>();

    const onClick = () => {
      store.commit('setCurrentUrl', 'become-dealer')
      window.location.href = store.state.pages["become-dealer"].url as string;
    };

    return {
      onClick,
      FaAngleRight: faAngleRight,
    };
  },
});
